import { useTranslation } from "react-i18next";
import { Gift, InputFormWrapper, WelfareTips } from "./atom";
import { BalanceTipType, ExtraWelfareTipType } from "../../types";
import BalanceIcon from "@/assets/icons/topup/balance-icon";
import ExtraIcon from "@/assets/icons/topup/extra-welfare-icon";
export function ExtraTips({
  balanceTip,
  extraTip,
}: {
  balanceTip?: BalanceTipType[];
  extraTip?: ExtraWelfareTipType[];
}) {
  const { t } = useTranslation("topup");

  const balanceTipList = balanceTip?.filter(
    (item: any) => item.content.length > 0
  );
  const extraTipList = extraTip?.filter((item: any) => item.content.length > 0);

  return (
    <InputFormWrapper>
      {((balanceTipList && balanceTipList.length > 0) ||
        (extraTipList && extraTipList.length > 0)) && (
        <WelfareTips>
          {balanceTipList && balanceTipList.length > 0 && (
            <Gift>
              <BalanceIcon fill="#fb6b4a" />
              <span>{t("topup_pay_balance_text")}</span>
              <span>
                {balanceTipList.map((item, index: number) => (
                  <span key={index}>
                    <span>{item.pre}</span>
                    <span>{item.content} </span>
                    {index < balanceTipList.length - 1 && (
                      <span className="space">|</span>
                    )}
                  </span>
                ))}
              </span>
            </Gift>
          )}
          {extraTipList && extraTipList.length > 0 && (
            <Gift>
              <ExtraIcon fill="#fb6b4a" />
              <span>{t("topup_extra_welfare")}</span>
              <span>
                {extraTipList.map((item, index: number) => (
                  <span key={index}>
                    <span>{item.pre}</span>
                    <span>
                      {Number(
                        item.content
                          .reduce((acc, v) => acc + Number(v), 0)
                          .toFixed(2)
                      )}
                    </span>
                    <span>&nbsp;{item.suf}</span>
                    {index < extraTipList.length - 1 && (
                      <span className="space">|</span>
                    )}
                  </span>
                ))}
              </span>
            </Gift>
          )}
        </WelfareTips>
      )}
    </InputFormWrapper>
  );
}
